import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setUserDataSuccess } from '../store/user/user.slice'
import { getAuthError, getAuthSuccess } from '../store/auth/auth.slice'
import { requestLogout, whatsAppReq } from '../store/auth/auth.thunks'
import { setAuthDataSuccess } from '../store/auth/authData.slice'
import { setContinueSessionModalShow } from '../store/modals/continueSessionModal.slice'
import { requestBalance } from '../store/balance/balance.thunks'
import { requestBalanceSettings } from '../store/balanceSettings/balanceSettings.thunks'
import { requestMenu } from '../store/menu/menu.thunks'
import { requestMessage } from '../store/message/message.thunks'
import { setMarket, setShowBetPlacingPopover, setRunner, setPrice, setPriceActual, setDelay, setStake, setMarketType, setMarketName, setFancyPrice, setIsCashOut, setIsSubmitting } from '../store/betPlacing/betPlacing.slice'
import { requestOpenBets } from '../store/openBets/openBets.thunks'
import { setIsLangauage, setLoginNew, setTab } from '../store/LoginNew/loginNew.slice'
import { setRuleRegulationPopUp } from './ruleRegulationPopup/ruleRegulationPopup.slice'
import { mainContainerHeightThunk, scrollPositionThunk, setClientWidthThunk } from './elementsParams/getElementsParams.thunk'
import { setSearchValues } from './navigationHeaderMenu/navigationHeaderMenu.slice'
import { setBannerPopUp } from './bannerPopUp/bannerPopUp.slice'
import { confirmMailVerification } from './profile/profile.thunks'
import { requestProfile } from './profile/profile.thunks'
// import { version } from 'process'
import { requestStakeButtons } from './stakes/stakes.thunks';
import { requestBetDelay } from './betPlacing/betPlacing.thunks';
import { getAllEventsOpenBetsError, getAllEventsOpenBetsSuccess, getEventPageOpenBetsError, getEventPageOpenBetsSuccess } from './openBets/openBets.slice';
import { setIsCashOutPopup } from './cashoutPopup/cashoutPopup.slice'
import { requestSupport } from './support/support.thunks';
import { setReferCode } from './signUp/signUp.slice'
import { requestSettings } from './timeSettings/timeSettings.thunks'
import { requestLogo } from './logo/logo.thunks'
import { requestNews } from './news/news.thunks'



export const connectApp = (wrappedProps) => (component) => {
    function mapStateToProps(state) {
        return {
            state: state,
            auth: state.auth,
            authData: state.authData,
            balance: state.balance,
            news: state.news,
            menu: state.menu,
            message: state.message,
            user: state.user,
            lastActivityDate: state.balance.lastActivityDate,
            continueSessionModalShow: state.continueSessionModalShow,
            showBetPlacingPopover: state.betPlacing.showBetPlacingPopover,
            showCashoutPopup: state.cashoutPopUp.isOpen,
            search: state.search,
            loginNew: state.loginNew,
            balanceInformationHeight: state.balanceInformationHeight,
            isPopUpOpenDispatch: state.editStakesPopUp.isOpen,
            isConfirmBetPopUpOpen: state.betPlacing.isConfirmBetPopUpOpen,
            rulesPopUp: state.rulesPopUp,
            ruleRegulationPopup: state.ruleRegulationPopup,
            elementsParams: state.elementsParams,
            banners: state.promotions,
            version: state.version,
            androidVersion: state.androidVersion,
            stakes: state.stakes,
            language: state.loginNew.language,
        }
    }

    function mapDispatchToProps(dispatch) {
        const actions = {
            getAuthError,
            getAuthSuccess,
            setAuthDataSuccess,
            setUserDataSuccess,
            setContinueSessionModalShow,
            setShowBetPlacingPopover,
            requestLogout,
            requestBalance,
            requestNews,
            requestBalanceSettings,
            requestMenu,
            requestMessage,
            requestOpenBets,
            setLoginNew,
            setTab,
            setRuleRegulationPopUp,
            mainContainerHeightThunk,
            scrollPositionThunk,
            setClientWidthThunk,
            setSearchValues,
            setBannerPopUp,
            whatsAppReq,
            confirmMailVerification,
            requestProfile,
            requestStakeButtons,
            requestBetDelay,
            setMarket,
            setRunner,
            setPrice,
            setPriceActual,
            setDelay,
            setStake,
            setMarketType,
            setMarketName,
            setFancyPrice,
            setIsCashOut,
            setIsSubmitting,
            getAllEventsOpenBetsSuccess,
            getAllEventsOpenBetsError,
            getEventPageOpenBetsSuccess,
            getEventPageOpenBetsError,
            setIsCashOutPopup,
            requestSupport,
            setReferCode,
            requestSettings,
            requestLogo,
            setIsLangauage
        }

        return { actions: bindActionCreators(actions, dispatch) }
    }

    return connect(mapStateToProps, mapDispatchToProps)(component)
}
